/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagecopyfailed3Inputs */

const en_ticketpagecopyfailed3 = /** @type {(inputs: Ticketpagecopyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not copy`)
};

const de_ticketpagecopyfailed3 = /** @type {(inputs: Ticketpagecopyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopieren hat nicht geklappt`)
};

/**
* | output |
* | --- |
* | "Could not copy" |
*
* @param {Ticketpagecopyfailed3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagecopyfailed3 = /** @type {((inputs?: Ticketpagecopyfailed3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagecopyfailed3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagecopyfailed3(inputs)
	return de_ticketpagecopyfailed3(inputs)
});
export { ticketpagecopyfailed3 as "ticketPageCopyFailed" }